var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16669 2.86005H5.66669C4.26656 2.86005 3.56649 2.86005 3.03171 3.13254C2.56131 3.37222 2.17885 3.75467 1.93917 4.22508C1.66669 4.75986 1.66669 5.45992 1.66669 6.86005V13.8601C1.66669 15.2602 1.66669 15.9602 1.93917 16.495C2.17885 16.9654 2.56131 17.3479 3.03171 17.5876C3.56649 17.8601 4.26656 17.8601 5.66669 17.8601H12.6667C14.0668 17.8601 14.7669 17.8601 15.3017 17.5876C15.7721 17.3479 16.1545 16.9654 16.3942 16.495C16.6667 15.9602 16.6667 15.2602 16.6667 13.8601V10.3601M6.66666 12.8601H8.06212C8.46977 12.8601 8.67359 12.8601 8.86541 12.814C9.03547 12.7732 9.19804 12.7058 9.34716 12.6145C9.51536 12.5114 9.65948 12.3673 9.94773 12.079L17.9167 4.11005C18.607 3.4197 18.607 2.30041 17.9167 1.61005C17.2263 0.919697 16.107 0.919696 15.4167 1.61005L7.44772 9.579C7.15946 9.86726 7.01534 10.0114 6.91227 10.1796C6.82088 10.3287 6.75354 10.4913 6.71271 10.6613C6.66666 10.8531 6.66666 11.057 6.66666 11.4646V12.8601Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/addNew.f7d95089fe966ef28164002e59e9cbf5.svg";
export { ForwardRef as ReactComponent };